import { cyan, red } from '@mui/material/colors';
import { Color, ThemeOptions } from '@mui/material';
const portalContainer = (): HTMLElement => document.getElementById('portal-root') ?? document.body;

const skyBlue: Color = {
  50: '#e4fafd',
  100: '#bdf2fa',
  200: '#91e9f7',
  300: '#64e0f3',
  400: '#43daf1',
  500: '#22d3ee',
  600: '#1eceec',
  700: '#19c8e9',
  800: '#14c2e7',
  900: '#0cb7e2',
  A100: '#ffffff',
  A200: '#daf7ff',
  A400: '#a7ecff',
  A700: '#8de6ff',
};
const themePreset = {
  palette: {
    primary: { main: cyan[500] },
    secondary: { main: cyan[500] },
  },
  components: {
    MuiModal: { defaultProps: { container: portalContainer } },
    MuiPopover: { defaultProps: { container: portalContainer } },
    MuiPopper: { defaultProps: { container: portalContainer } },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          /* Calendar header: "December 2025" - prevent wrapping, keep compact */
          '& > div:first-of-type > div:first-of-type': {
            whiteSpace: 'nowrap',
            fontSize: '0.95rem',
          },
        },
      },
    },
  },
} as ThemeOptions;

export default themePreset;
